<template>
  <i class="fa fa-fw fa-comments-o"></i>
</template>

<script>
export default {
  name: 'ChannelAppIcon',
};
</script>

<style scoped>
.fa-comments-o {
  color: #4822f3;
}
</style>



// WEBPACK FOOTER //
// ChannelAppIcon.vue?277e298a